export enum GridId {
  // SEARCH key changed to "SEARCH_V2" to reset the search AgGrid and add the relevance column, improving initial result sorting.
  SEARCH = "SEARCH_V2",
  CITY_PLANNER_FEATURES_TABLE = "CITY_PLANNER_FEATURES_TABLE",
  CITY_PLANNER_SUMMARY = "CITY_PLANNER_SUMMARY",
  CITY_PLANNER_REPORT_SUMMARY = "CITY_PLANNER_REPORT_SUMMARY",
  WORKSPACE = "WORKSPACE",
  RECENT_PROJECTS = "RECENT_PROJECTS",
  SHARED_PROJECTS = "SHARED_PROJECTS",
  STARRED_PROJECTS = "STARRED_PROJECTS",
}
